const state = {
  // Список все точек на карте
  points: [],

  // Флаг загружаются ли в текущий момент точки для карты
  isPointsLoading: false,
};

export default state;
